import { IActionFn, IPageData } from '@/store/types';
import { IModuleState } from './types';
import { $http } from '@/axios';
import store from '@/store';

// 查询型材列表
export const querySectionBarPage: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setSectionBarPage', { ...state.sectionBarPage, loading: true });
    const res: IPageData = await $http.post('/v1/data/ue/section/search', payload);
    const { list: data, total, pageNum, pageSize } = res;
    commit('setSectionBarPage', { data, total, pageNum, pageSize });
  } catch (e) {
    commit('setSectionBarPage', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 查询型材详情
export const querySectionBarDetail: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setSectionBarDetail', { data: null, loading: true });
    const res = await $http.get(`/v1/data/ue/section/${payload}/detail`);
    commit('setSectionBarDetail', { data: res, loading: false });
  } catch (e) {
    commit('setSectionBarDetail', { data: null, loading: false });
  }
};

// 新增型材(并上传配置文件)
export const addSectionBar: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    const formData = new FormData();
    formData.append('name', payload.name);
    formData.append('file', payload.file);
    if (payload.fullpath) {
      formData.append('fullpath', payload.fullpath);
    }
    await $http.post('/v1/ue/section/add', formData);
    store.commit('common/setToast', { visible: true, text: '新增成功' });
  } finally {
    commit('setLoading', false);
  }
};

// 编辑型材(并上传配置文件)
export const editSectionBar: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    const formData = new FormData();
    formData.append('name', payload.name);
    formData. append('code', payload.code);
    if (payload.fullpath) {
      formData.append('fullpath', payload.fullpath);
    }
    if (payload.file) {
      formData.append('file', payload.file);
    }
    await $http.post('/v1/ue/section/update', formData);
    store.commit('common/setToast', { visible: true, text: '保存成功' });
  } finally {
    commit('setLoading', false);
  }
};

// 删除型材
export const deleteSectionBar: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/ue/section/delete', payload);
  } finally {
    commit('setConfirm', { visible: false });
  }
};
